import { Typography } from '@mui/material';
import { useL10n } from '@uplift/hooks';
import { useChangeSessionReasonsQuery } from '@uplift/queries';
import { ChangeSessionReasonTypes, UserRole } from '@uplift/types';

import { ModalStep } from '../types';

export type SubtitleProps = {
  step: ModalStep;
  reason: string | null;
};

export const Subtitle: React.VFC<SubtitleProps> = ({ reason, step }) => {
  const l10n = useL10n();
  const { reasons } = useChangeSessionReasonsQuery(UserRole.patient, ChangeSessionReasonTypes.cancel);

  if (step !== 'note') {
    return null;
  }

  return (
    <Typography variant="subtitle1" component="p" color="textSecondary">
      {l10n.schedule.cancelAppointment.reason(reasons?.find(x => x.id === reason)?.description ?? '')}
    </Typography>
  );
};
